module.exports = __webpack_public_path__ + "media/images/emblems/Tentlingen-coat_of_arms-6ae2a0eb818b293bd069ea435e8963e1.svg";